import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_VOICE_AGENTS, SET_VOICE_AGENT_CONSENT, SET_VOICE_AGENT_CONSENT_MUTE } from './actionTypes';
import { isSafeAgentId, sanitizeAgents } from './functions';
const DEFAULT_STATE = {
    agents: {},
    consent: {}
};
/**
 * Drops entries for agents no longer present (stale consent once an agent leaves).
 *
 * @param {AgentFlags} map - The per-agent flags to prune.
 * @param {IVoiceAgents} agents - The currently known agents.
 * @returns {AgentFlags}
 */
function pruneToAgents(map, agents) {
    const pruned = {};
    for (const [agentId, value] of Object.entries(map)) {
        if (agentId in agents) {
            pruned[agentId] = value;
        }
    }
    return pruned;
}
/**
 * Whether a per-agent flag may be recorded for this id: it must be safe (`in` reports __proto__ as present)
 * and currently known.
 *
 * @param {IVoiceAgentsState} state - The feature state.
 * @param {string} agentId - The agent id.
 * @returns {boolean}
 */
function isKnownAgent(state, agentId) {
    return isSafeAgentId(agentId) && agentId in state.agents;
}
ReducerRegistry.register('features/voice-agents', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_VOICE_AGENTS: {
            const agents = sanitizeAgents(action.agents ?? {});
            return {
                ...state,
                agents,
                consent: pruneToAgents(state.consent, agents)
            };
        }
        case SET_VOICE_AGENT_CONSENT:
            return isKnownAgent(state, action.agentId)
                ? { ...state, consent: { ...state.consent, [action.agentId]: action.allowed } }
                : state;
        case SET_VOICE_AGENT_CONSENT_MUTE:
            return { ...state, consentMute: action.consentMute };
    }
    return state;
});
